import api from '../../services/api';

/*
 * The requests of the legacy `usePickupRequests` hook. The backend scopes the
 * couriers, the pickup requests and the eligible orders to the seller's company.
 *
 * Creating a pickup request and assigning orders call the courier's API (Samex),
 * so both book real work on the courier's side.
 */

export const getPickupCouriersRequest = () => api.get('pickup-requests/couriers/');

/** The session's warehouses, with the address and hours to seed the form. */
export const getPickupWarehousesRequest = (courier) =>
  api.get('pickup-requests/warehouses/', { params: { courier } });

/** @param {{courier?: string, date_from?: string, date_to?: string, status?: string}} params */
export const getPickupRequestsRequest = (params) => api.get('pickup-requests/', { params });

/** @param {object} body - See `buildPickupRequestPayload`. */
export const createPickupRequestRequest = (body) => api.post('pickup-requests/', body);

/**
 * Stores a pickup the courier's support created, without calling the courier.
 * @param {object} body - See `buildManualPickupPayload`.
 */
export const createManualPickupRequestRequest = (body) => api.post('pickup-requests/manual/', body);

/** @param {{courier?: string, date_from?: string, date_to?: string}} params */
export const getEligibleOrdersRequest = (params) =>
  api.get('pickup-requests/eligible-orders/', { params });

export const assignOrdersToPickupRequest = (pickupId, orderIds) =>
  api.post(`pickup-requests/${pickupId}/assign-orders/`, { order_ids: orderIds });

export const requestManifestRequest = (pickupId) =>
  api.post(`pickup-requests/${pickupId}/manifest/`);
